// Pokladna, krok Informace o vás: rychlá registrace v okně s nativním formulářem z /registrace/
// Texty jsou v administraci (HTML kód v patičce, blok .mytexts .myregistration), JS má fallback
const myRegistrationStorageKey = "myregistration-step2";
let myRegistrationForm = null;

function myRegistrationText(selector, fallback) {
    const text = $(".mytexts .myregistration " + selector).first().text().trim();
    return text.length ? text : fallback;
}

// Nativní AJAX Shoptetu nesmí běžet souběžně se stažením registrace (session, CSRF)
function myRegistrationWhenIdle(callback) {
    if ($.active > 0) {
        $(document).one("ajaxStop", function () {
            myRegistrationWhenIdle(callback);
        });
    } else {
        callback();
    }
}

// Formulář z /registrace/: id dostanou prefix, aby se nepraly s polem e-mailu v kroku 2
function myRegistrationPrepareForm(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const form = doc.getElementById("register-form");

    if (!form) {
        return null;
    }

    const $form = $(document.importNode(form, true));

    $form.attr("id", "myregistration-form").addClass("myregistration-form");
    $form.find("[id]").each(function () {
        $(this).attr("id", "myregistration-" + $(this).attr("id"));
    });
    $form.find("label[for]").each(function () {
        $(this).attr("for", "myregistration-" + $(this).attr("for"));
    });
    $form.find("button[type='submit']").text(myRegistrationText(".myregistration-submit", "Zaregistrovat se"));

    return $form;
}

function myRegistrationPrefill($form) {
    const email = ($("#order-form #email").val() || "").trim();
    const name = ($("#order-form #billFullName").val() || "").trim();

    if (email.length) {
        $form.find("input[name='email']").val(email);
    }
    if (name.length) {
        $form.find("input[name='billFullName']").val(name);
    }
}

function myRegistrationOpen($opener) {
    const title = myRegistrationText(".myregistration-heading", "Rychlá registrace");
    const intro = myRegistrationText(".myregistration-intro", "Zvolte si heslo a máte hotovo. Košík i rozpracovaná objednávka vám zůstanou.");

    if ($opener.hasClass("is-loading")) {
        return;
    }

    if (myRegistrationForm) {
        myRegistrationShow(title, intro);
        return;
    }

    $opener.addClass("is-loading");

    myRegistrationWhenIdle(function () {
        $.get("/registrace/", function (html) {
            myRegistrationForm = myRegistrationPrepareForm(html);
        }, "html").always(function () {
            $opener.removeClass("is-loading");

            if (myRegistrationForm) {
                myRegistrationShow(title, intro);
            } else {
                window.location.href = "/registrace/";
            }
        });
    });
}

function myRegistrationShow(title, intro) {
    const $content = $("<div class='myregistration-modal'>" +
        "<h2 class='myregistration-modal-title'></h2>" +
        "<p class='myregistration-modal-intro'></p>" +
        "<div class='myregistration-modal-error' role='alert' hidden></div>" +
    "</div>");

    $content.find(".myregistration-modal-title").text(title);
    $content.find(".myregistration-modal-intro").text(intro);

    const $form = myRegistrationForm.clone();
    myRegistrationPrefill($form);

    // Listener přímo na formuláři běží před Shoptetím CSRF listenerem na document, ten pak nativně neodešle
    $form.on("submit", function (e) {
        e.preventDefault();
        myRegistrationSubmit(this);
    });
    $content.append($form);

    shoptet.modal.open({
        html: shoptet.content.colorboxHeader + "<div class='myregistration-holder'></div>" + shoptet.content.colorboxFooter,
        className: shoptet.modal.config.classSm,
        width: shoptet.modal.config.widthSm,
        maxWidth: shoptet.modal.config.maxWidth,
        onComplete: function () {
            $("#colorbox .myregistration-holder").replaceWith($content);
            shoptet.modal.resize();

            const $email = $form.find("input[name='email']");
            const $focus = $email.val() ? $form.find("input[name='password']") : $email;
            $focus.trigger("focus");
        },
    });
}

function myRegistrationValidate(form) {
    let valid = true;

    $(form).find("input.js-validate-required").each(function () {
        const empty = !this.value.trim().length;
        const badEmail = this.type === "email" && !empty && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.value.trim());

        if (empty || badEmail) {
            shoptet.validator.addErrorMessage(this, "validatorRequired");
            if (valid) {
                $(this).trigger("focus");
            }
            valid = false;
        } else {
            shoptet.validator.removeErrorMessage(this, "validatorRequired");
        }
    });

    return valid;
}

// Rozepsané údaje kroku 2 přežijí reload po registraci (vrací se jen do prázdných polí)
function myRegistrationSaveStep2() {
    const values = {};

    $("#order-form").find("input[type='text'], input[type='email'], input[type='tel'], textarea").each(function () {
        if (this.name && this.name !== "surname" && this.value.trim().length) {
            values[this.name] = this.value;
        }
    });

    try {
        sessionStorage.setItem(myRegistrationStorageKey, JSON.stringify(values));
    } catch (e) {
        return;
    }
}

function myRegistrationRestoreStep2() {
    let values = null;

    try {
        values = JSON.parse(sessionStorage.getItem(myRegistrationStorageKey) || "null");
        sessionStorage.removeItem(myRegistrationStorageKey);
    } catch (e) {
        return;
    }

    if (!values) {
        return;
    }

    $.each(values, function (name, value) {
        const $field = $("#order-form").find("[name='" + name + "']").first();
        if ($field.length && !$field.val()) {
            $field.val(value);
        }
    });
}

// CSRF token jen tehdy, když ho e-shop zapnutý má — stejně jako nativní odeslání formuláře
function myRegistrationToken(form) {
    if (shoptet.csrf && shoptet.csrf.enabled && typeof shoptet.csrf.injectToken === "function") {
        shoptet.csrf.injectToken(form);
    }
}

function myRegistrationSubmit(form) {
    const $form = $(form);
    const $error = $form.closest(".myregistration-modal").find(".myregistration-modal-error");
    const $button = $form.find("button[type='submit']");

    $error.attr("hidden", true).text("");

    if (!myRegistrationValidate(form) || $form.hasClass("is-sending")) {
        shoptet.modal.resize();
        return;
    }

    myRegistrationToken(form);
    $form.addClass("is-sending");
    $button.prop("disabled", true);

    myRegistrationWhenIdle(function () {
        fetch($form.attr("action"), {
            method: "POST",
            body: new URLSearchParams(new FormData(form)),
            credentials: "same-origin",
        }).then(function (response) {
            return response.text().then(function (html) {
                return { ok: response.ok, html: html };
            });
        }).then(function (result) {
            // Úspěch jen při kladném signálu: Shoptet přesměruje do účtu a dataLayer odpovědi má registered: true
            const doc = new DOMParser().parseFromString(result.html, "text/html");
            const $messages = $(doc).find(".messages .msg-error");
            const registered = result.ok && /"registered":\s*true/.test(result.html);

            if (registered) {
                myRegistrationSaveStep2();
                window.location.reload();
                return;
            }

            const text = $messages.map(function () {
                return $(this).text().trim();
            }).get().join(" ");

            $error.text(text.length ? text : myRegistrationText(".myregistration-failed", "Registraci se nepodařilo dokončit. Zkuste to prosím znovu.")).removeAttr("hidden");
            $form.removeClass("is-sending");
            $button.prop("disabled", false);
            shoptet.modal.resize();
        }).catch(function () {
            $error.text(myRegistrationText(".myregistration-failed", "Registraci se nepodařilo dokončit. Zkuste to prosím znovu.")).removeAttr("hidden");
            $form.removeClass("is-sending");
            $button.prop("disabled", false);
            shoptet.modal.resize();
        });
    });
}

function myRegistration() {
    const $login = $("#order-form .login-button").first();

    if (!$login.length || getShoptetDataLayer("customer").registered || $(".myregistration-box").length) {
        return;
    }

    const $box = $("<div class='myregistration-box'>" +
        "<button type='button' class='btn btn-primary myregistration-box-button'></button>" +
        "<p class='myregistration-box-benefit'></p>" +
    "</div>");

    $box.find(".myregistration-box-button").text(myRegistrationText(".myregistration-button", "Rychlá registrace (5 s)"));
    $box.find(".myregistration-box-benefit").text(myRegistrationText(".myregistration-benefit", "Příště nakoupíte rychleji a v účtu uvidíte přehled svých objednávek."));
    $box.insertAfter($login);
}

$(document).ready(function () {
    if ($(".id--17").length) {
        myRegistrationRestoreStep2();
        myRegistration();

        $(document).on("click", ".myregistration-box-button", function (e) {
            e.preventDefault();
            myRegistrationOpen($(this));
        });
    }
});
